import { AfterViewInit, Directive, ElementRef, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { isDefined } from '@fi-shared/utils';

@Directive({
    selector: '[fiAutofocus]',
    standalone: false,
})
export class AutofocusDirective implements AfterViewInit, OnInit, OnChanges {
    @Input() fiAutofocus: boolean | '' = true;
    @Input() fiAutofocusTimeout: number; // autofocus is not working when we create post from mobile app without timeout
    @Input() fiAutofocusDetectOnChange: boolean;
    constructor(private elementRef: ElementRef) {}

    ngOnInit() {}

    ngAfterViewInit() {
        this.focusElement();
    }

    private focusElement() {
        if (this.fiAutofocus === true || this.fiAutofocus === '') {
            if (isDefined(this.fiAutofocusTimeout)) {
                {
                    setTimeout(() => this.elementRef.nativeElement.focus(), this.fiAutofocusTimeout);
                }
            } else {
                this.elementRef.nativeElement.focus();
            }
        }
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.fiAutofocus && this.fiAutofocusDetectOnChange) this.focusElement();
    }
}
